module.exports = __webpack_public_path__ + "static/hero-fb26b95ef807a16fb53055ac73bdc1c1.png";